<template>
  <div :class="$style.container">
    <div :class="$style.row">
      <div :class="$style.label">Тип:</div>
      <div :class="$style.value">
        <div :class="$style.icon">
          <app-icon :key="category.id" :name="category.icon" size="20px" :style="{color: category.color}" />
        </div>
        {{ category.name }}
      </div>
    </div>
    <div :class="$style.row">
      <div :class="$style.label">Ответственный:</div>
      <div :class="$style.value">
        <template v-if="manager">
          <div :class="$style.icon">
            <app-avatar :name="manager.name" :img="manager.avatar_url | imgPath" size="28px" />
          </div>
          <span>{{ manager.name }}</span>
        </template>
        <span v-else :class="$style.empty">не назначено</span>
      </div>
    </div>
    <div :class="$style.row">
      <div :class="$style.label">Исполнитель:</div>
      <div :class="$style.value">
        <template v-if="performer">
          <div :class="$style.icon">
            <app-avatar :name="performer.name" :img="performer.avatar_url | imgPath" size="28px" />
          </div>
          <span>{{ performer.name }}</span>
        </template>
        <span v-else :class="$style.empty">не назначено</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:     "IssueInfo",
  props:    ['issue'],
  computed: {
    category() {
      return this.$store.getters['common/tasks/categoryById'](this.issue.category_id);
    },
    manager() {
      return this.issue.manager;
    },
    performer() {
      return this.issue.performer;
    },
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },
  },
};
</script>

<style lang="scss" module>
.container {
  border: 1px solid #F0F0F0;
  border-radius: 4px;
  padding: 15px 20px;
  margin-bottom: 20px;
}

.row {
  display: flex;
  margin-bottom: 20px;
  font-size: 1.15rem;
}

.label {
  font-weight: 600;
  margin-right: .3em;
}

.value {
  display: flex;
  align-items: flex-start;
}

.icon {
  margin-right: .5rem;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty {
  opacity: .5;
  font-style: italic;
}
</style>
